import { render, staticRenderFns } from "./centreLeft2Chart.vue?vue&type=template&id=6124620a&scoped=true&"
import script from "./centreLeft2Chart.vue?vue&type=script&lang=js&"
export * from "./centreLeft2Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124620a",
  null
  
)

export default component.exports